// extracted by mini-css-extract-plugin
module.exports = {"trainingTemplateList":"styles_trainingTemplateList__2V4GZ"};